module.exports = __webpack_public_path__ + "assets/ic_tree04.a918b49c.svg";